export default "__VITE_ASSET__c3eaf87a__"